import * as React from 'react';
import classNames from 'classnames/bind';
import FlagFilled from 'mini-fluent-svg-icons/lib/icons/FlagFilled';
import PinRegular from 'mini-fluent-svg-icons/lib/icons/PinRegular';
import styles from './MailListItemIconBar.scss';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';
import { getPropertyIconName } from '../utils/getPropertyIconName';
import { type PropertyIcons } from '../schema/PropertyIcons';

// Remark: We have to share css file with MailListItem since we need to trigger child hover selectors
// off of the MailListItem container css class
const MaxPropertyIconsToDisplay = 3;

export interface MailListItemIconBarProps {
    isFlagged: boolean;
    isPinned: boolean;
    unreadCount: number;
    propertyIcons: PropertyIcons[];
    messageClassIcon: PropertyIcons;
    className?: string;
}

/*
Renders the bar for both action icons and property icons
*/
export class MailListItemIconBar extends React.Component<MailListItemIconBarProps, {}> {
    private renderPropertyIconElements(): JSX.Element[] {
        const propertyIcons: PropertyIcons[] = this.props.propertyIcons;
        const propertyIconElements: JSX.Element[] = [];
        const addMessageClassIcon =
            this.props.messageClassIcon && this.props.messageClassIcon !== -1;

        const maxPropertiesToDisplay = Math.min(
            addMessageClassIcon ? propertyIcons.length + 1 : propertyIcons.length,
            MaxPropertyIconsToDisplay
        );

        const commonPropertyIconCss = classNames(styles.icon);
        let propertyIconsAdded = 0;

        // If message class icon is present then always want to display it.
        if (addMessageClassIcon) {
            propertyIconsAdded++;

            const messageClassiconContainerStyles = classNames(commonPropertyIconCss);

            propertyIconElements.push(
                <FluentSvgIcon
                    key={this.props.messageClassIcon.toString()}
                    icon={getPropertyIconName(this.props.messageClassIcon)}
                    iconContainerStyles={messageClassiconContainerStyles}
                />
            );
        }

        // Add other class icons
        for (let i = 0; i < maxPropertiesToDisplay - propertyIconsAdded; i++) {
            const propertyIcon = propertyIcons[i];
            let propertyIconStyle = classNames(commonPropertyIconCss);

            if (propertyIcon === 1) {
                propertyIconStyle = classNames(propertyIconStyle, styles['icon--red']);
            }

            if (this.props.unreadCount > 0 && propertyIcon === 35) {
                propertyIconStyle = classNames(propertyIconStyle, styles['icon--themeColor']);
            }

            propertyIconElements.push(
                <FluentSvgIcon
                    key={propertyIcon.toString()}
                    icon={getPropertyIconName(propertyIcon)}
                    iconContainerStyles={propertyIconStyle}
                />
            );
        }

        if (this.props.isFlagged) {
            const flagImageClassNames = classNames(commonPropertyIconCss, styles['icon--red']);
            propertyIconElements.push(
                <FluentSvgIcon
                    key={'flagIcon'}
                    icon={FlagFilled}
                    iconContainerStyles={flagImageClassNames}
                />
            );
        }

        if (this.props.isPinned) {
            const pinnedImageClassName = classNames(
                commonPropertyIconCss,
                styles['icon--themeColor']
            );
            propertyIconElements.push(
                <FluentSvgIcon
                    key={'pinnedIcon'}
                    icon={PinRegular}
                    iconContainerStyles={pinnedImageClassName}
                />
            );
        }

        return propertyIconElements;
    }

    render() {
        const propertyIconsElement = this.renderPropertyIconElements();
        const shouldShowIconBar = propertyIconsElement?.length;
        return shouldShowIconBar ? (
            <div className={classNames(styles.iconsContainer, this.props.className)}>
                {propertyIconsElement}
            </div>
        ) : null;
    }
}
